// Core
import React from 'react';
import PropTypes from 'prop-types';

// Style
import { StyledTrip } from './style';
import { useTranslation } from 'react-i18next';
import ActionLink from 'components/commonComponents/ActionLink';


const Trip = (props) => {
  const { t } = useTranslation();
  // pass `trip` (an item from the API) or the individual props; explicit props win
  const {
    trip,
    title = trip?.tripName,
    para = trip?.description,
    image = trip?.coverImage,
    premium = trip?.isPremium,
    author = trip?.author?.userName,
    visualApp = !!trip?.isVisualAppAvailable,
    handleOnClick,
    ...rest
  } = props;
  // many trips have an empty description or just dots; only real text counts
  const text = (para || '').replace(/\s+/g, ' ').trim();
  const hasText = /[\p{L}\p{N}]/u.test(text);
  return (
    <StyledTrip {...rest} onClick={handleOnClick} >
      <img src={image} alt={title} />
      <h1>{title}</h1>
      <h4>{author}</h4>
      {hasText ?
        <p>{text.substring(0, 80)}{text.length > 80 && '...'} <ActionLink>{t('learn_more')}</ActionLink></p>
        :
        <p className='__no_desc'><ActionLink>{t('learn_more')}</ActionLink></p>
      }
      {premium && <div className='__premium'>{t('premium')}</div>}
      {visualApp && <div className='__visual_app'>{t('special_edition')}</div>}
    </StyledTrip>
  );
};

export default Trip;

Trip.propTypes = {
  trip: PropTypes.object,
  title: PropTypes.string,
  para: PropTypes.string,
  image: PropTypes.string,
  author: PropTypes.string,
  handleOnClick: PropTypes.func,
  premium:PropTypes.bool,
  visualApp: PropTypes.bool
};
